import { getOnboardingConfig } from '../../api/onboardingVariant';
import { useOnboardingStage } from './useOnboardingStage';

export const useIsOnboardingCompleted = ({ skip = false }: { skip?: boolean } = {}) => {
    const { publishStageSlug } = getOnboardingConfig();

    return useOnboardingStage(publishStageSlug, { skip }).isCompleted;
};
